export const AccordionData = [
    {
        id: 1,
        doctor: "Faruk",
        profession:"Doctor",
        dept: "Medical",
        service_type: "Consultation",
        time: "09:00am",
        date: "26-feb-2025",
        appointment_type: "test",
        reason_for_appointment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,qui officia deserunt mollit anim id est laborum.."
    },
    {
        id: 2,
        doctor: "Suleman",
        service_type: "Consultation",
        profession:"Doctor",
        dept: "Medical",
        time: "10:00am",
        date: "24-feb-2025",
        appointment_type: "test",
        reason_for_appointment: "Lorem it aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. "
    }
]